import styled from 'styled-components';
import { QuestionTipContainer } from '../../../../../../styles/QuestionTipContainer.styles';
import { Space } from 'antd';
import { blueDark01, white, blueLink, black } from '../../../../../../styles/colors';

export const AIAMaterialContainer = styled('div')`
    display: flex;
    flex-direction: column;
    padding: 32px 0;
`;

export const InstructionsText = styled('div')`
    // color: ${blueDark01};
    font-family: 'Proxima Nova';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    flex: 1;
    width: 60%;

    strong {
        font-family: 'Proxima N W15 Bold';
        font-style: normal;
        font-weight: 400;
    }
`;

export const ToolbarSpacer = styled.div`
    flex: 1;
`;

export const MFToolbar = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    font-family: 'Inter', sans-serif;
    padding: 12px 0;
`;

export const NumericSelect = styled.select`
    height: 32px;
    padding: 0 28px 0 10px;
    font-size: 15px;
    border-radius: 6px;
    border: 1px solid #c9cfd6;
    background: #fff;
    cursor: pointer;
    appearance: none;
    font-weight: 600;

    background-image: url("data:image/svg+xml;utf8,<svg fill='%23222' width='12' height='12' viewBox='0 0 24 24'><path d='M7 10l5 5 5-5' /></svg>");
    background-repeat: no-repeat;
    background-position: right 8px center;

    &:focus {
        outline: none;
        border-color: #003366;
    }
`;

export const InlineLabel = styled.span`
    margin-left: 6px;
    font-size: 15px;
    color: #555;
`;

export const PaginationInline = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;

export const ChevronButton = styled.button`
    border: none;
    background: transparent;
    color: #444;
    font-size: 18px;
    cursor: pointer;
    opacity: ${({ disabled }) => (disabled ? 0.3 : 1)};
    pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};

    &:hover:not(:disabled) {
        color: #00284d;
    }
`;

export const PageBox = styled.div`
    width: 36px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1.5px solid #8aa0b5;
    border-radius: 6px;
    font-size: 17px;
    font-weight: 600;
    color: #01274a;
    background: #fff;
`;

export const PagesLabel = styled.span`
    font-size: 15px;
    color: #666;
`;
export const SpaceEnd = styled(Space)`
    width: 100%;
    justify-content: flex-end;
`;
export const CustomTopContainer = styled('div')`
    input {
        height: 32px;
        font-weight: normal;
        font-family: 'Proxima N W15 Bold';
        font-style: normal;
        font-weight: 400;
        font-size: 13px;
        line-height: 16px;
        color: ${blueDark01};
        padding: 8px 13px;
    }
    .ant-space-item:last-child {
        width: 16px !important;
    }
`;

export const ImpactAreaCell = styled('div')`
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 24px;
`;

export const ImpactAreaIndicator = styled('div')<{
    color: string;
    filled?: boolean;
    halfFilled?: boolean;
    whiteCenter?: boolean;
}>`
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: ${(props) =>
        props.filled || props.whiteCenter ? props.color : 'transparent'};
    border: 2px solid ${(props) => props.color};
    position: relative;
    cursor: pointer;

    ${(props) =>
        props.halfFilled &&
        `
        &::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 50%;
            height: 100%;
            background-color: ${props.color};
            border-radius: 50% 0 0 50%;
        }
    `}

    ${(props) =>
        props.whiteCenter &&
        `
        &::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background-color: ${white};
        }
    `}
`;

export const OptimizationX = styled('span')`
    color: ${blueDark01};
    font-family: 'Proxima Nova';
    font-size: 14px;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 24px;
`;

export const SearchAndPaginationToolbar = styled('div')`
    display: flex;
    gap: 16px;
    align-items: center;
    margin-bottom: 20px;
`;

export const RowsPerPageContainer = styled('div')`
    display: flex;
    align-items: center;
    gap: 8px;
    align-self: flex-end;
`;

export const RowsPerPageDropdownButton = styled('button')`
    padding: 8px 8px;
    display: flex;
    gap: 8px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    background-color: #fff;
    cursor: pointer;
    width: 48px;
    height: 32px;
    transition: border-color 0.2s ease;
    align-items: center;

    &:hover {
        border-color: #8aa0b5;
    }

    &:focus {
        outline: none;
        border-color: #003366;
    }
`;

export const RowsPerPageNumber = styled.div`
    color: ${blueDark01};
    font-family: 'Proxima Nova';
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
`;

export const PaginationRightContainer = styled('div')`
    margin-left: auto;
`;

export const ImpactAreaValue = styled('span')`
    color: #00273b;
`;

export const PaginationContainer = styled.div`
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 30px;
`;

export const RightSection = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;
`;

export const RowsPerPageButton = styled.button`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 4px 8px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    background-color: #fff;
    cursor: pointer;
    min-width: 50px;
    font-size: 14px;

    &:hover {
        border-color: #40a9ff;
    }

    &:focus {
        outline: none;
        border-color: #40a9ff;
        box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
    }
`;
export const PerPageLabel = styled.span`
    font-size: 13px;
    color: #666666;
    white-space: nowrap;
`;

export const InstructionLink = styled.a`
    cursor: pointer;
    color: #134fbd;
    font-family: 'Proxima Nova';
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    text-decoration: none;

    &:hover {
        color: ${blueLink};
        text-decoration: underline;
    }
    
    &:active {
        color: ${black};
        text-decoration: underline;
    }
`;
export const PartsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const PartRow = styled.div`
    display: flex;
    gap: 4px;
`;

export const PartText = styled.span`
    font-size: 13px;
`;

export const PartTextBold = styled.span`
    font-family: "Proxima N W15 Bold";
    white-space: nowrap;
`;

export const ListingBadge = styled.div`
    font-size: 10px;
    color: #00273b;
    margin-top: 4px;
    display: flex;
    align-items: center;
    gap: 2px;
    font-family: 'Proxima Nova';
    font-weight: 400;
`;

export const InfoIcon = styled.span`
    cursor: help;
`;

export const ManufacturerContainer = styled.div`
`;

export const TableDataLink = styled.a`
    color: #134FBD;
    font-family: "Proxima N W15 Bold";
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
`;

export const ProductName = styled.span`
    font-family: "Proxima N W15 Bold";
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
`;

export const ImpactAreaBlankDashWrapper = styled.span<{width: number}>`
    display: flex;
    width: ${props => props.width}px;
    min-height: 24px;
    align-items: center;
`;

export const ImpactAreaBlankDash = styled.span<{width: number}>`
    display: flex;
    align-items: center;
    justify-content: center;
    color: #666;
    
    font-family: "Proxima Nova";
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 160% */
    width: 20px;
    height: auto;
`;

export const ContactUs = styled('a')`
    color: #134FBD;
    font-family: "Proxima N W15 Bold";
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 12px;
`;
export { QuestionTipContainer };

export const CertificationOrStandardWrapper = styled.div`
    display: flex;
    height: 24px;
    align-items: center;
`;

export const LowEmittingCertifierLink = styled.a`
    color: ${blueLink};
    font-family: 'Proxima N W15 Bold';
    font-style: normal;
    font-weight: 400;
`;

export const MfDivisionTitleWrapper = styled.button`
    display: flex;
    gap: 2px;
    background: transparent;
    border: none;
    padding: 0;
    align-items: center;

    :hover {
        cursor: pointer;
    }
`;

export const MfDivisionTitleText = styled.div`
    color: #264758;
    font-family: "Proxima N W15 Bold";
    font-size: 10px;
    line-height: 12px;
    font-style: normal;
    font-weight: 400;
`;

export const MfDivisionSortButton = styled.img`
    width: 7px;
    height: 7px;
    background: transparent;
    border: none;
    padding: 0;
    vertical-align: none;
`;

export const ProductNameWithDetailsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const ProductDescription = styled.div`
    font-size: 13px;
    color: #666;
    line-height: 16px; 
    font-family: 'Proxima Nova';
    font-style: normal;
    font-weight: 400;
`;
